<template>
<div>
  <mainBar></mainBar>

  <div class="container">
    <div class="row">
        <div class="col-sm-11">
          <markdown></markdown>
        </div>
    </div>    
  </div>
</div>
</template>

<script>
import mainBar from 'components/MainBar';
import { affix } from 'vue-strap'
import markdown from './userDoc.md';

export default {
  name: 'Main',
  data () {
    return {
    }
  },
  components:{
      mainBar,
      affix,
      markdown
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Main.vue?532d7a92